import { Form, Icon, Input } from 'antd'
import React from 'react'
import LoadingButton from 'src/components/styled/LoadingButton'
import styled from 'styled-components/macro'

const { Item } = Form

const NormalRegisterForm = ({ submit, form, user }) => {
  const { getFieldDecorator } = form
  const { isLoading } = user

  const handleSubmit = () => {
    form.validateFields((error, values) => {
      if (!error) {
        submit({
          ...values,
          email: values.email.toLowerCase(),
        })
      } else console.log('Error', error)
    })
  }

  return (
    <StyledForm
      onSubmit={event => {
        event.preventDefault()
        if (!isLoading) {
          handleSubmit()
        }
      }}
      className='login-form'
    >
      <Item>
        <FieldLabel>Full Name</FieldLabel>
        {getFieldDecorator('name', {
          rules: [{ required: true, message: 'Please input your name' }],
        })(
          <Input
            prefix={<StyledInputIcon type='smile' />}
            placeholder='Your Name'
            size='large'
          />,
        )}
      </Item>
      <Item>
        <FieldLabel>Email Address</FieldLabel>
        {getFieldDecorator('email', {
          rules: [
            { required: true, message: 'Please input your email address' },
            { type: 'email', message: 'The input is not valid email' },
          ],
        })(
          <Input
            prefix={<StyledInputIcon type='user' />}
            placeholder='name@company.com'
            size='large'
          />,
        )}
      </Item>
      <Item>
        <FieldLabel>Password</FieldLabel>
        {getFieldDecorator('password', {
          rules: [{ required: true, message: 'Please enter a password' }],
        })(
          <Input.Password
            prefix={<StyledInputIcon type='lock' />}
            type='password'
            placeholder='Password'
            size='large'
          />,
        )}
      </Item>
      <ActionItem>
        <LoadingButton
          type='primary'
          htmlType='submit'
          className='login-form-button register-submit-button'
          loading={isLoading}
          size='large'
        >
          Register
        </LoadingButton>
        <AuthLink href='/login'>Back to Log In</AuthLink>
      </ActionItem>
    </StyledForm>
  )
}

const StyledForm = styled(Form)`
  .ant-form-item {
    margin-bottom: 14px;
  }

  .ant-input-affix-wrapper .ant-input {
    border-radius: 8px;
  }

  .register-submit-button {
    width: 100%;
    margin-bottom: 10px;
    font-weight: 600;
    border-radius: 8px;
    height: 42px;
  }
`

const FieldLabel = styled.span`
  display: block;
  margin-bottom: 6px;
  text-align: left;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: ${({ theme }) => theme.colours.seaweedGreen};
`

const StyledInputIcon = styled(Icon)`
  color: rgba(0, 0, 0, 0.32);
`

const ActionItem = styled(Item)`
  margin-bottom: 10px;
`

const AuthLink = styled.a`
  color: ${({ theme }) => theme.colours.seaweedGreen};
  font-size: 0.86rem;
  margin-top: 2px;

  &:hover {
    color: ${({ theme }) => theme.colours.avocadoGreen};
    text-decoration: underline;
  }
`

const WrappedNormalRegisterForm = Form.create({ name: 'register' })(
  NormalRegisterForm,
)

export default WrappedNormalRegisterForm
